import { render, staticRenderFns } from "./RumahRuko.vue?vue&type=template&id=0fafd2a1&scoped=true"
import script from "./RumahRuko.vue?vue&type=script&lang=js"
export * from "./RumahRuko.vue?vue&type=script&lang=js"
import style0 from "./RumahRuko.vue?vue&type=style&index=0&id=0fafd2a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fafd2a1",
  null
  
)

export default component.exports